export enum ColumnsVisibilityTestIds {
  TRIGGER_BUTTON = 'columns-visibility-trigger',
  WRAPPER = 'columns-visibility-wrapper',
  COLUMN_ITEM_PREFIX = 'columns-visibility-item-',
  SAVE_BUTTON = 'columns-visibility-apply-button',
  RESTORE_BUTTON = 'columns-visibility-restore-button',
}
